module.exports = __webpack_public_path__ + "media/assets/images/category/SpanishBday-48ccbad2ad20b28ef1b01ce051cd0a65.png";